
import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { Redirect } from "react-router-dom";
import Card from "react-bootstrap/esm/Card";
import ReactHtmlParser from 'react-html-parser';
import webio from "../../services/webio";

export default function Listavagaswebio() {
  // pág atual e numero de pags
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);

  // chama api de acordo com numero de pags
  useEffect(() => {
    webio.get("/vagas", {
      params: { page: page }
    }).then(response => {
      setPosts(response.data);
    }).catch(error => {
      return <Redirect to='/not_found/'/>
    });
  }, [page, setPosts]);

  //crio a memoria no estado
  const [searchTerm, setSearchTerm] = useState("");
  
  function submit(e) {
    e.preventDefault()
  }

  return (
    <div className="py-0">
        <div className="mb-5">
          <h4 className="mb-2"> Procure sua vaga aqui.</h4>
          <form onSubmit={submit} inline className="mb-5">
            <input id="buscavaga" value={searchTerm} className="py-4 form-control" type="text" placeholder="por exemplo: auxiliar, gerente, diretor, motorista..."  onChange={(event) =>  setSearchTerm(event.target.value) }  />
            <button type="submit" className="d-block d-sm-none btn btn-sm btn-dark mt-1 float-right">
              Procurar
            </button>
          </form>
        </div>
      <Row >
          {posts &&
            posts.length &&
            posts.filter((post)=> {
              if (searchTerm =="") {
                return post                
              } else if (post.titulo.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                return post
              }
            }).map((post, index) => {
              return (  
                  <Col sm={12} className="mb-4" key={post.id}>
                    <Card body bg='light'>
                        <h3>{post.titulo}</h3>
                        <p> Quantidade de Vagas: {post.quantidade_vagas}</p>
                        <p>{ ReactHtmlParser(post.descricao) }</p>
                        <a href="https://webio.aparecida.go.gov.br/sime" target="_blank"  rel="noopener noreferrer">
                           <button className="btn btn-dark btn-sm mt-3">Quero me candidatar</button>
                        </a>
                    </Card>
                  </Col>
              );         
            })}
      </Row>
      {/* <Row >
          {posts &&
            posts.length &&
            posts.map((post, index) => {
              return (
                  <Col sm={12} className="mb-4" key={post.id}>
                    <Card body bg='light'>
                        <h3>{post.titulo}</h3>
                        <p> Quantidade de Vagas: {post.quantidade_vagas}</p>
                        <p>{ ReactHtmlParser(post.descricao) }</p>
                        <a href="https://webio.aparecida.go.gov.br/sime" target="_blank"  rel="noopener noreferrer">
                           <button className="btn btn-dark btn-sm mt-3">Quero me candidatar</button>
                        </a>
                    </Card>
                  </Col>
              );         
            })}
      </Row> */}
    </div>
  );
}